var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu',{key:_vm.sid,staticClass:"no-print",staticStyle:{"z-index":"50"},attrs:{"drawer":_vm.drawer}}),_c('router-view',{on:{"change":_vm.setMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }